import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7a8c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-body min-w-min" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 ml-2 text-center" }, "Instructor Feedback", -1))
const _hoisted_3 = {
  key: 0,
  class: "content min-w-min"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center my-auto font-bold"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Messages from your instructor ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" will appear here ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

import Message from '../../models/Message';
import FeedbackCardComponent from './FeedbackCardComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructorFeedbackComponent',
  props: {
  feedback: {
    type: Array<Message>,
    default: () => []
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (__props.feedback.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.feedback, (feedback) => {
            return (_openBlock(), _createBlock(FeedbackCardComponent, {
              key: feedback.authorId,
              feedback: feedback,
              class: "mb-4 ml-2 h-1/4"
            }, null, 8, ["feedback"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_8))
  ]))
}
}

})